import { useStore } from "../store.js";

const inputClass =
  "w-full rounded-lg border border-node-border bg-canvas px-2 py-1.5 text-sm text-ink outline-none focus:border-accent";

export function FlowInspector() {
  const flow = useStore((state) =>
    state.selectedEdgeIds.length === 1 && state.selectedNodeIds.length === 0
      ? state.flows.find((f) => f.id === state.selectedEdgeIds[0])
      : undefined,
  );
  const nodes = useStore((state) => state.nodes);
  const updateFlow = useStore((state) => state.updateFlow);
  const removeFlow = useStore((state) => state.removeFlow);
  const selectEdge = useStore((state) => state.selectEdge);

  if (!flow) {
    return null;
  }

  const nameOf = (id: string) => nodes.find((node) => node.id === id)?.name ?? "?";

  return (
    <aside
      key={flow.id}
      className="pointer-events-auto absolute left-4 top-4 flex w-72 flex-col gap-3 rounded-2xl border border-node-border bg-node-bg/95 p-5 shadow-2xl backdrop-blur"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wide text-ink-muted">Connection</span>
        <button
          type="button"
          onClick={() => selectEdge(null)}
          className="text-sm text-ink-muted hover:text-ink"
          aria-label="Close inspector"
        >
          Close
        </button>
      </div>

      <p className="text-sm text-ink">
        {nameOf(flow.sourceNodeId)} <span className="text-ink-muted">to</span>{" "}
        {nameOf(flow.targetNodeId)}
      </p>

      <p className="text-xs text-ink-muted">
        Amounts live on the nodes, so this is just a wire. Edit the figures on the nodes it
        connects.
      </p>

      <label className="block">
        <span className="mb-1 block text-xs text-ink-muted">Label</span>
        <input
          className={inputClass}
          value={flow.label}
          onChange={(event) => updateFlow(flow.id, { label: event.target.value })}
        />
      </label>

      <button
        type="button"
        onClick={() => void removeFlow(flow.id)}
        className="mt-2 rounded-lg border border-warning/50 px-3 py-1.5 text-sm text-warning hover:bg-warning/10"
      >
        Delete connection
      </button>
    </aside>
  );
}
